// src/customHooks/useConfirmDataDeletionRequest.ts
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
import { CONFIRM_DATA_DELETION_REQUEST } from 'graphql/service';

export const useConfirmDataDeletionRequest = () => {
  const { showGlobalError } = useGlobalAlerts();

  const [confirmMutation, { loading }] = useMutation(CONFIRM_DATA_DELETION_REQUEST);

  const confirmDataDeletionRequest = useCallback(async (token: string) => {
    try {
      const res = await confirmMutation({
        variables: {
          data: {
            token,
          },
        },
      });

      return Boolean(res?.data?.confirmDataDeletionRequest?.ok);
    } catch (error: any) {
      showGlobalError(
        error?.message || 'Failed to confirm the deletion request.'
      );
      return false;
    }
  }, [confirmMutation, showGlobalError]);

  return {
    confirmDataDeletionRequest,
    loading,
  };
};